import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import SideBar from "../../Components/Navbar/Sidebar";
import "./goUsers.css";
import instance from "../../Components/Apis/axios";
import { goUsers, toggleButtongoUsers } from "../../Components/Apis/apis";
import Pajination from "../../helpingFiles/Pagination/Pajination";
import Modal from "react-modal";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Head from "../../Components/ontabletop/head";
import { useLocation, useNavigate } from "react-router-dom";

const Campaings = () => {
  const [edit, setedit] = useState(false);
  const [posts, setPosts] = useState([]);
  const [gosts, setGosts] = useState([]);
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [postPerpage, setPostPerPage] = useState(10);
  const [show, setShow] = useState(false[0]);
  const [query, setQuery] = useState("");
  let locations = useLocation();
  let navigation = useNavigate();
  const path = locations.pathname;
  const [user, setUser] = useState();
  const [campaign, setCampaign] = useState();
  const [userType, setUserType] = useState("");

  const fetchPost = async () => {
    const data = await goUsers(path);
    if (data.message === "You are not authorized for this page") {
      navigation("/");
    } else {
      setPosts(data);
      setTotal(data.length);
    }
  };

  useEffect(() => {
    fetchPost();
  }, []);

  const getData = async (userid) => {
    const data = await toggleButtongoUsers(userid, path);
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      setGosts(data);
    }
  };

  const toggle = (index) => {
    if (show === index) {
      return setShow(null);
    }
    setShow(index);
  };

  const changeStatus = async () => {
    const { data } = await instance.post(`users/changeStatus?path=${path}`, {
      id: campaign.id,
      user: campaign.user,
      status: userType,
    });
    if (data.message === "You are not authorized for this Action") {
      alert(data.message);
    } else {
      getData(campaign.user);
      setedit(false);
      setUserType("");
    }
  };

  const siteNavigation = (site) => {
    if (site) {
      const url = `https://www.gohoardings.com/seedetails/${site.category_name}/${site.page_title}/${site.code}`;
      window.open(url, "_blank");
    } else {
      alert("Site information is missing!");
    }
  };

  const indexOfLastPage = page * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const currentPosts = posts.slice(indexOfFirstPage, indexOfLastPage);

  const CityNameImage = [
    {
      id: 1,
      value: "New",
      label: "New",
    },
    {
      id: 2,
      value: "Success",
      label: "Success",
    },
    {
      id: 3,
      value: "Reject",
      label: "Reject",
    },
  ];

  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages">
        <div className="page-title">
          <h4>ORDERS</h4>
        </div>
        <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
        <div>
          <table className="table table-boarder table-hover table-striped table-sm">
            <thead className="thead-darK">
              <tr>
                <th scope="col ">S.NO</th>
                <th scope="col">Client Name</th>
                <th scope="col">Email</th>
                <th scope="col">Contact NO</th>
                <th scope="col">All Sites</th>
              </tr>
            </thead>
            <tbody>
              {currentPosts
                .filter((obj) => {
                  if (query == "") {
                    return obj;
                  } else if (
                    obj.firstname.toLowerCase().includes(query.toLowerCase()) ||
                    obj.email.toLowerCase().includes(query.toLowerCase())
                  ) {
                    return obj;
                  }
                })
                .map((obj, index) => (
                  <>
                    <tr key={obj.id}>
                      <td>{index + 1}</td>
                      <td>
                        {obj.firstname}
                        {obj.lastname}
                      </td>
                      <td>{obj.email}</td>

                      <td>{obj.phonenumber}</td>

                      <td>
                        <button
                          onClick={() => {
                            getData(obj.userid);
                            toggle(index);
                          }}
                          className="button is-small is-info show-btn border-0"
                        >
                          Show
                        </button>
                      </td>
                    </tr>
                    <tr className="modalView">
                      {show === index ? (
                        <td colSpan={7}>
                          {gosts.length > 0 && (
                            <>
                              <div>
                                <div className="dataModal">
                                  <table className="table table-boarder table-hover table-striped  table-sm mb-0">
                                    <thead>
                                      <tr>
                                        <th scope="col ">S.No</th>
                                        <th scope="col">Campaign Name</th>
                                        <th scope="col">Location</th>
                                        <th scope="col">Site Detail</th>
                                        <th scope="col">Start Date</th>
                                        <th scope="col">End Date</th>
                                        <th scope="col ">Status</th>
                                        <th scope="col ">Update</th>
                                      </tr>
                                    </thead>
                                    <tbody className="mb-0">
                                      {gosts.map(
                                        (posts.id = (value, index) => (
                                          <tr key={value.id}>
                                            <td className="text-center">
                                              {index + 1}
                                            </td>
                                            <td>{value.campaign_name}</td>
                                            <td>
                                              {value.campaign_city
                                                ? value.campaign_city
                                                : " No Data"}
                                            </td>
                                            <td>
                                              <button
                                                className="show-btn border-0"
                                                onClick={(e) => {
                                                  siteNavigation(value);
                                                }}
                                              >
                                                Show
                                              </button>
                                            </td>
                                            <td>
                                              {value.start_date
                                                ? value.start_date.slice(0, 10)
                                                : " No Data"}
                                            </td>
                                            <td>
                                              {value.end_date
                                                ? value.end_date.slice(0, 10)
                                                : " No Data"}
                                            </td>
                                            <td>
                                              {value.status == 2 ? (
                                                <span className="text-success">
                                                  Success
                                                </span>
                                              ) : (
                                                <>
                                                  {value.status == 1 ? (
                                                    <span className="text-primary">
                                                      New
                                                    </span>
                                                  ) : (
                                                    <span className="text-danger">
                                                      {" "}
                                                      Reject
                                                    </span>
                                                  )}
                                                </>
                                              )}
                                            </td>
                                            <td>
                                              <button
                                                className="show-btn border-0"
                                                onClick={() => {
                                                  setedit(true);
                                                  setUser(obj);
                                                  setCampaign(value);
                                                }}
                                              >
                                                Edit
                                              </button>
                                            </td>
                                          </tr>
                                        ))
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          )}
                        </td>
                      ) : null}
                    </tr>
                  </>
                ))}
            </tbody>
          </table>
        </div>
        <Modal isOpen={edit} className={"form_modal"}>
          <button className="closeToggle" onClick={() => setedit(false)}>
            <i className="fa-solid fa-multiply text-danger"></i>
          </button>
          <div
            className="permissionFilter"
            style={{ justifyContent: "center" }}
          ></div>
          {user && (
            <>
              <div className="text-center camp-detail">
                <div className="row">
                  <div className="col heading-camp-box">
                    <h6 className="heading-camp p-2 fw-bold">Client Details</h6>
                    <div className="p-2 text-start">
                      <h6>
                        Name : {user.firstname} {user.lastname}
                      </h6>
                      <h6>Email : {user.email} </h6>
                      <h6>Contact : {user.phonenumber} </h6>
                    </div>
                  </div>
                  <div className="col heading-camp-box">
                    <h6 className="heading-camp p-2 fw-bold">
                      Campaign Details
                    </h6>
                    <div className="p-2 text-start">
                      <h6>
                        Category :
                        {campaign.media_type ? campaign.media_type : " No Data"}
                      </h6>
                      <h6>
                        Location :
                        {campaign.campaign_city
                          ? campaign.campaign_city
                          : " No Data"}
                      </h6>
                      <h6>
                        Start :
                        {campaign.start_date
                          ? campaign.start_date.slice(0, 10)
                          : " No Data"}
                      </h6>
                      <h6>
                        End :
                        {campaign.end_date
                          ? campaign.end_date.slice(0, 10)
                          : " No Data"}
                      </h6>

                      <h6 className="d-flex">
                        <span className="mt-2">Status : </span>
                        <DropdownButton
                          title={
                            userType ? (
                              userType
                            ) : (
                              <>
                                {campaign.status == 2 ? (
                                  "Success"
                                ) : (
                                  <>
                                    {campaign.status == 1 ? " New" : "Reject"}
                                  </>
                                )}
                              </>
                            )
                          }
                          id="select-media-box"
                          onSelect={(e) => setUserType(e)}
                          className=" dropend ms-2"
                        >
                          {CityNameImage.map((el, i) => (
                            <Dropdown.Item
                              eventKey={el.value}
                              className="p-2 mt-0 dropend"
                              key={i}
                            >
                              {el.label}
                            </Dropdown.Item>
                          ))}
                        </DropdownButton>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-grid  mx-auto ">
                <button
                  class="btn heading-camp-btn  fw-bold "
                  type="button"
                  onClick={changeStatus}
                >
                  Done
                </button>
              </div>
            </>
          )}
        </Modal>
        <Pajination
          setPostPerPage={setPostPerPage}
          postPerpage={postPerpage}
          page={page}
          setPage={setPage}
          total={total}
        />
      </div>
    </div>
  );
};
export default Campaings;
